/* Estrani - kortingsladder in winkelwagen. Door Claude gebouwd, veilig te verwijderen. */
(function () {
  'use strict';
  var CFG = null, busy = false, timer = null, lastCount = -1, fetching = false;

  function cfg() {
    if (CFG) return CFG;
    var el = document.getElementById('ai-cart-ladder-data');
    if (!el) return null;
    try { CFG = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!CFG.tiers || !CFG.tiers.length) CFG = null;
    return CFG;
  }

  function fmt(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] !== undefined ? vars[k] : m;
    });
  }

  function state(count, c) {
    var t = c.tiers, n = t.length, k = -1, i;
    for (i = 0; i < n; i++) if (count >= t[i].qty) k = i;
    var seg = 100 / n;
    var pos;
    if (k === n - 1) pos = 100;
    else {
      var prevQty = k < 0 ? 0 : t[k].qty;
      var prevPos = k < 0 ? 0 : (k + 1) * seg;
      var nextQty = t[k + 1].qty;
      var span = Math.max(1, nextQty - prevQty);
      pos = prevPos + Math.min(1, Math.max(0, (count - prevQty) / span)) * seg;
    }
    var msg, max = false;
    if (k === n - 1) {
      max = true;
      msg = fmt(c.text_max, { pct_actief: t[k].pct });
    } else {
      var need = t[k + 1].qty - count;
      var vars = {
        n: need,
        artikel: need === 1 ? c.word_one : c.word_many,
        pct: t[k + 1].pct,
        pct_actief: k < 0 ? 0 : t[k].pct
      };
      msg = fmt(k < 0 ? c.text_before : c.text_mid, vars);
    }
    return { k: k, pos: pos, msg: msg, max: max, seg: seg };
  }

  function build(count, c) {
    var s = state(count, c), t = c.tiers, n = t.length, i;
    var marks = '', labels = '';
    for (i = 0; i < n; i++) {
      var left = (i + 1) * s.seg;
      var on = i <= s.k ? ' is-on' : '';
      marks += '<span class="ai-ladder__mark' + on + '" style="left:' + left + '%"></span>';
      labels += '<span class="ai-ladder__label' + on + '" style="left:' + left + '%">' +
        '<span class="ai-ladder__qty">' + t[i].qty + ' ' + c.word_many + '</span>' +
        '<span class="ai-ladder__pct">−' + t[i].pct + '%</span></span>';
    }
    return '<p class="ai-ladder__title">' + c.title + '</p>' +
      '<div class="ai-ladder__bar"><span class="ai-ladder__fill" style="width:' + s.pos + '%"></span>' +
      '<span class="ai-ladder__marks">' + marks + '</span></div>' +
      '<div class="ai-ladder__labels">' + labels + '</div>' +
      '<p class="ai-ladder__msg">' + s.msg + '</p>';
  }

  function hosts() {
    var list = [];
    document.querySelectorAll('cart-drawer-component .cart-drawer__inner').forEach(function (el) {
      var h = el.querySelector(':scope > .theme-drawer__header');
      list.push({ parent: el, after: h });
    });
    document.querySelectorAll('.cart-page__items').forEach(function (el) {
      list.push({ parent: el, after: null });
    });
    return list;
  }

  function paint(count) {
    var c = cfg();
    if (!c) return;
    var html = count > 0 ? build(count, c) : '';
    var max = count > 0 && state(count, c).max;
    busy = true;
    hosts().forEach(function (h) {
      var node = h.parent.querySelector(':scope > .ai-ladder');
      if (!count) { if (node) node.hidden = true; return; }
      if (!node) {
        node = document.createElement('div');
        node.className = 'ai-ladder';
        if (h.after && h.after.nextSibling) h.parent.insertBefore(node, h.after.nextSibling);
        else if (h.after) h.parent.appendChild(node);
        else h.parent.insertBefore(node, h.parent.firstChild);
      }
      node.hidden = false;
      node.classList.toggle('ai-ladder--max', max);
      if (node.innerHTML !== html) node.innerHTML = html;
    });
    busy = false;
  }

  function readCount() {
    var b = document.querySelector('cart-drawer-component .theme-drawer__badge');
    if (b) {
      var v = parseInt((b.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(v)) return v;
    }
    return null;
  }

  function refresh(force) {
    var n = readCount();
    if (n !== null && !force) {
      if (n !== lastCount || !document.querySelector('.ai-ladder')) { lastCount = n; paint(n); }
      return;
    }
    if (fetching) return;
    fetching = true;
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCount = c.item_count; paint(c.item_count); })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  function schedule(force) {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(force); }, 60);
  }

  /* Horizon sluit de la als het aangeklikte element al uit de DOM weg is voor de klik
     bij de dialog aankomt (isClickedOutside -> panel.contains(losgekoppelde knop) = false).
     Dat gebeurt bij het vuilbakje. We stoppen die klik voor hij de dialog bereikt. */
  function guardClose() {
    document.querySelectorAll('cart-drawer-component').forEach(function (el) {
      if (el.__aiCloseGuard) return;
      el.__aiCloseGuard = true;
      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.nodeType === 1 && !t.isConnected) e.stopPropagation();
      });
    });
  }

  /* Totaallabel en vertrouwensbalk in de la. Beide komen uit de sectie-instellingen. */
  function tidyTotals() {
    var c = cfg();
    if (!c || !c.total_label) return;
    document.querySelectorAll('.cart-totals__total-label').forEach(function (el) {
      if (el.textContent.trim() !== c.total_label) el.textContent = c.total_label;
    });
  }

  function trustBadges() {
    var tpl = document.getElementById('ai-cart-trust');
    if (!tpl) return;
    document.querySelectorAll('cart-drawer-component .cart__ctas').forEach(function (box) {
      if (box.querySelector(':scope > .ai-trust')) return;
      box.appendChild(tpl.content.cloneNode(true));
    });
  }

  function extras() {
    tidyTotals();
    trustBadges();
  }

  function boot() {
    if (!cfg()) return;
    guardClose();
    refresh(true);
    extras();
    ['shopify:cart:lines-update', 'cart:update', 'cart:updated', 'variant:update'].forEach(function (n) {
      document.addEventListener(n, function () { schedule(true); });
      document.body.addEventListener(n, function () { schedule(true); });
    });
    var obs = new MutationObserver(function () { schedule(false); extras(); });
    document.querySelectorAll('cart-drawer-component, .cart-page__items, cart-icon').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('cart-icon, [href$="/cart"], .cart-items-component')) schedule(false);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
